import { CloudDownload, Warning } from "@mui/icons-material";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { useCallback, useContext } from "react";
import { CartaFsContext, downloadFile, FileUri } from ".";
import {Estimator, ProgressTracker} from '@contextualize/cartafs/dist/util/Estimator'


export function DownloadChips(props: { fsUrls: string | string[] }) {

    const { cartaFs } = useContext(CartaFsContext);

    const _downloadFile = useCallback(async (fileKey: string) => {
        try {
            await downloadFile(cartaFs, fileKey)
        } catch (e: any) {
            console.error(e);
        }
    }, [cartaFs]);

    return (<>
        {
            ([] as string[]).concat(props.fsUrls).filter(a => !!a).map(FileUri.extract)
            .map((value) => 
                <Chip key={value.meta.file} icon={<CloudDownload />} onClick={(e) => { e.preventDefault(); _downloadFile(value.meta.file) }} label={value.name} />
            )
        }
    </>)
}

export interface FailedFile{
    name: string;
    error: string;
}

export function FailedFileChips(props: { fsUrls: FailedFile | FailedFile[] }){

    return (
        <>
        {([] as FailedFile[]).concat(props.fsUrls).filter(a => !!a).map((file,i)=>{
            return(
            <Tooltip title={<div style={{whiteSpace: 'pre'}}>{file.error}</div>} key={i}>
                <Chip icon={<Warning />} label={file.name} color="error"/>
            </Tooltip>
            )
        })}
        </>
        
    )
}

export interface UploadFile {
    href: string;
    name: string;
    progress: number;
    estimate: {
        etaCalc: ProgressTracker,
        estimateBuffer: Estimator;
        /** Time remaining to upload in seconds */
        eta: Date;
    }
}

function UploadChip(props: {fsUrl: UploadFile}){

    let remainingTime = (props.fsUrl.estimate.eta.getTime() - Date.now())/1000;
    if(remainingTime < 0){
        remainingTime = 0;
    }

    const minutes = Math.floor(remainingTime/60).toFixed(0).padStart(1, '0')
    const seconds = Math.floor(remainingTime%60).toFixed(0).padStart(2, '0')

    return (
        <Tooltip title={(
            <>
                <div>{props.fsUrl.progress.toFixed(2)}%</div>
                <div>Estimated time remaining {minutes}:{seconds} </div>
            </>
        )}>
            <Chip avatar={<CircularProgress variant="determinate" size="2em" value={props.fsUrl.progress} />} label={props.fsUrl.name} />
        </Tooltip>
    )
}

export function UploadingChips(props: { fsUrls: UploadFile | UploadFile[] }) {

    return (<>
        {([] as UploadFile[]).concat(props.fsUrls).filter(a => !!a)
            .map((value) => <UploadChip key={value.href} fsUrl={value}/>)}
    </>)
}
